import { section } from "@/glow";
import { animateStandard, shouldAnimate } from "@/lib/animation";

section("icon-with-text-columns", {
  onLoad() {
    if (shouldAnimate(this.container)) {
      this.animateIconWithTextColumns = animateStandard(this.container);
    }
  },

  onUnload() {
    this.animateIconWithTextColumns?.destroy();
  },
});
